export const getOtherapps = (state) =>
  state.otherapps;



// WEBPACK FOOTER //
// ./src/store/selectors/otherapps.js